import { render } from "./security-settings.vue?vue&type=template&id=3f812c05"
import script from "./security-settings.vue?vue&type=script&lang=js"
export * from "./security-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__